import type { Player } from "."

export const getPlayerNames = ({
  players,
}: {
  players: Player.Collection
}): Player.Name[] => {
  return players.map(({ name }) => name)
}
